import { PagedList } from "@shared/list/paged-list";
import { EInvoiceDto } from "..";
import { BaseApiResponse, ClientType, PaginationListRequest } from "../common";

export class AddClientRequest {
  Type: ClientType;
  Name: string;
  Email: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  CountryAlpha2Code: string;
  Siret: string | null;
  TvaNumber: string | null;
}

export interface AddClientResponse extends BaseApiResponse<CreateClientError> {
  Client: EInvoiceClientDto | null;
}

export interface DeleteClientRequest {
  ForceDelete: boolean;
}

export interface DeleteClientResponse
  extends BaseApiResponse<DeleteClientError> {
  AttachedInvoiceCount: number | null;
}

export class EditClientRequest {
  Type: ClientType;
  Name: string;
  Email: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  CountryAlpha2Code: string;
  Siret: string | null;
  TvaNumber: string | null;
}

export interface EditClientResponse extends BaseApiResponse<EditClientError> {
  Client: EInvoiceClientDto | null;
}

export interface EInvoiceClientDto {
  Id: number;
  ClientId: number | null;
  Type: ClientType;
  Name: string;
  Email: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  CountryAlpha2Code: string;
  Siret: string | null;
  TvaNumber: string | null;
  Invoices: EInvoiceDto[];
}

export class EInvoiceClientListRequest extends PaginationListRequest {}
export interface EInvoiceClientListModel extends PagedList<EInvoiceClientDto> {}

export enum EditClientError {
  NotFound = 1,
  Dupplicate = 2,
}

export enum CreateClientError {
  Dupplicate = 1,
}

export enum DeleteClientError {
  NotFound = 1,
  AttachedInvoice = 2,
}
